"use client";
import { cn } from "@scott/ui/client";
import type { BrandConfig } from "@ui-d2c/types";

export interface footerLogoProps {
  brand: BrandConfig;
  className?: string;
}

const FooterLogo = ({ brand, className }: footerLogoProps) => {
  const footerLogoURL = `/assets/${brand.value}-logo/logo_mini.png`;

  return (
    <div className="py-4">
      <div
        className={cn(
          "flex flex-row items-center gap-4 justify-self-center bg-transparent md:container",
          className
        )}
      >
        <div className="flex-1 justify-items-center py-8">
          <div className="h-[50%] w-full border-neutral-lighter border-b-[1px]" />
        </div>

        <div>
          <img alt="logo" className="max-h-8 px-6" src={footerLogoURL} />
        </div>

        <div className="flex-1 justify-items-center py-8">
          <div className="h-[50%] w-full border-neutral-lighter border-b-[1px]" />
        </div>
      </div>
    </div>
  );
};

FooterLogo.displayName = "footerLogo";

export { FooterLogo };
